import React, {useContext, useEffect, useState} from 'react';
import styles from './InviteFriends.module.css';

import ConnectWalletHeader from '../header/ConnectWalletHeader';
import LeftPanel from '../SwapLeftPanel/LeftPanel';
import {SwapMainAppContext} from '../../SwapMainAppContext';
import {USDI_API_URL, DISTRIBUTION_API_URL} from '../../configs/config';

import copy_icon from '../static_files/invite copy.svg';

import text_icon from '../static_files/invite text.png';
import x_icon from '../static_files/invite x.svg';
import tele_icon from '../static_files/invite telegram.svg'
import whatsapp_icon from '../static_files/invite whatsapp.svg';
import qr_icon from "../static_files/invite qr.svg"

import {APP_URL} from '../utils'
import {fetchPortfolioTrackRecordsRoundFourDigit} from "../linechart/fetchDailyPortfolioData";
import KiraQRCodeModal from "./KiraQRCodeModal";

function InviteFriends() {

    const [email, setEmail] = useState(null);
    const {showNotification} = useContext(SwapMainAppContext);

    // Main wallet address to display
    const [walletAddress, setWalletAddress] = useState('');
    // For the top-right button or email-based connection
    const [emailWalletAddress, setEmailWalletAddress] = useState(null);
    const [showPanel, setShowPanel] = useState(false);


// Add these four
    const [totalReferrals, setTotalReferrals] = useState('--');
    const [balancesOfReferrals, setBalancesOfReferrals] = useState('--');
    const [estimatedAnnualBonus, setEstimatedAnnualBonus] = useState('--');
    const [earnedRewards, setEarnedRewards] = useState('--');

    const [isWalletLoading, setIsWalletLoading] = useState(true);
    const [referralCode, setReferralCode] = useState('');
    const [referralsData, setReferralsData] = useState([]);
    const [ninetyDayApy, setNinetyDayApy] = useState([]);
    const [isReferralsLoading, setIsReferralsLoading] = useState(true);
    const [showQrCodeModal, setShowQrCodeModal] = useState(false);
    // ======= Clears user data on disconnect
    const handleClearAccountData = () => {
        setEmail(null);
        setWalletAddress('');
        setEmailWalletAddress(null);
        setReferralCode('')
        setReferralsData([])
    };

    // 2) Check localStorage at mount — if NO wallet is found => stop loading
    useEffect(() => {
        const lastWallet = localStorage.getItem("lastConnectedWallet");
        if (!lastWallet) {
            setIsWalletLoading(false);
        }
    }, []);

    useEffect(() => {
        if (walletAddress || email) {
            setIsWalletLoading(true);
        }
    }, [walletAddress, email]);


    // ========== Restore from localStorage if user has email/wallet stored ==========
    useEffect(() => {
        const userEmail = localStorage.getItem('userEmail');
        if (userEmail) {
            setEmail(userEmail);
        }
        const storedAddr = localStorage.getItem('emailUserWalletAddress');
        if (storedAddr) {
            setWalletAddress(storedAddr);
            setEmailWalletAddress(storedAddr);
        }
    }, []);


    // ========== Fetch contact info from your DB once we know wallet/email ==========
    useEffect(() => {
        if (!walletAddress && !email) {
            return;
        }
        const fetchInfo = async () => {
            try {

                if (
                    !walletAddress ||
                    walletAddress.trim() === "" ||
                    walletAddress === "null" ||
                    walletAddress === "--"
                ) {
                    setWalletAddress("--");
                    return;
                }

                const res = await fetch(
                    `${USDI_API_URL}/usdi_holders_info_table_solana?address=${walletAddress}`
                );
                if (res.status === 404) {
                    setIsWalletLoading(false);
                    return;
                }
                if (!res.ok) {
                    throw new Error(`Error fetching user data: ${res.statusText}`);
                }

                const data = await res.json();
                if (!data || !data[0]) {
                    setIsWalletLoading(false);
                    return;
                }
                if (data[0] && data[0].referral_code) {
                    setReferralCode(data[0].referral_code)
                }
                setIsWalletLoading(false);

            } catch (err) {
                console.error(err);
                showNotification("error", `Error fetching account info: ${err}`);
                setIsWalletLoading(false);

            }
        };

        fetchInfo();
    }, [walletAddress, email, showNotification]);


    useEffect(() => {
        const fetchReferralsData = async () => {
            try {
                const res = await fetch(
                    `${USDI_API_URL}/usdi_holders_info_table_solana?referrers_referral_code=${referralCode}`
                );
                if (!res.ok) {
                    throw new Error(`Error fetching data: ${res.statusText}`);
                }
                const data = await res.json();
                setReferralsData(data);  // 将返回结果存入 state

                if (data && data.length > 0) {
                    setTotalReferrals(data.length);

                    const sumBalances = data.reduce((acc, row) => {
                        return acc + (parseFloat(row.balance_of_usdi || 0));
                    }, 0);
                    setBalancesOfReferrals(sumBalances.toFixed(2));
                    const userAddressList = data.map((row) => row.address);

                    // 4) 发起 POST 请求到后端 get_earned_rewards
                    //    (请根据后端真实地址替换 /get_earned_rewards)
                    console.log("body", JSON.stringify({user_addresses: userAddressList}))
                    const rewardsRes = await fetch(`${DISTRIBUTION_API_URL}/get_earned_rewards`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({user_addresses: userAddressList})
                    });

                    if (!rewardsRes.ok) {
                        throw new Error(`Error fetching earned rewards: ${rewardsRes.statusText}`);
                    }

                    const rewardsData = await rewardsRes.json();

                    let totalRewards = 0;
                    data.forEach((row) => {
                        const addrLower = (row.address || '').toLowerCase();
                        const rewardVal = parseFloat(rewardsData[addrLower] || 0);
                        totalRewards += rewardVal;
                    });
                    setEarnedRewards(totalRewards.toFixed(2));

                }

            } catch (error) {
                console.error(error);
                showNotification("error", `Error fetching referrals data: ${error}`);
            } finally {
                setTimeout(() => {
                    setIsReferralsLoading(false);
                }, 1000);
            }
        };

        fetchReferralsData();
    }, [referralCode]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await Promise.any([
                    fetchPortfolioTrackRecordsRoundFourDigit().catch(() => null),
                ]);
                if (data) {
                    setNinetyDayApy(data.ninetyDayApy * 0.01)
                }
            } catch (error) {
                console.error("Error fetching portfolio track records:", error);
            }
        };

        fetchData();
    }, []);


    const handleCopy = (e) => {
        e.stopPropagation();

        if (!referralCode) return;

        navigator.clipboard
            .writeText(`https://${APP_URL}/invite-friend/${referralCode}`)
            .then(() => {
                showNotification("success", "Link successfully copied to clipboard");
            })
            .catch((err) => {
                showNotification("error", `Failed to copy link: ${err}`);
            });
    };

    function handleShare(platform) {
        const textShare = "Share Kira with friends and earn KRA when they start to gain USDi interest.";
        const referralUrl = `https://${APP_URL}/invite-friend/${referralCode}`;

        switch (platform) {

            case 'x': {
                const textShare = "Share Kira with friends and earn KRA when they start to gain USDi interest.";
                const referralUrl = `https://${APP_URL}/invite-friend/${referralCode}`;

                const intent = new URL('https://twitter.com/intent/tweet');
                intent.searchParams.set('text', textShare.replace(/\s*\n+\s*/g, ' ')); // strip any accidental newlines
                intent.searchParams.set('url', referralUrl);

                window.open(intent.toString(), '_blank', 'noopener,noreferrer');
                break;
            }
            case 'telegram':
                window.open(
                    `https://t.me/share/url?url=${encodeURIComponent(referralUrl)}&text=${encodeURIComponent(
                        textShare
                    )}`,
                    '_blank'
                );
                break;

            case 'whatsapp':
                window.open(
                    `https://api.whatsapp.com/send?text=${encodeURIComponent(
                        `${textShare}\n${referralUrl}`
                    )}`,
                    '_blank'
                );
                break;

            case 'qr':
                setShowQrCodeModal(true)
                break;

            default:
                break;
        }
    }

    return (
        <div className={styles.mainContainer}>
            <LeftPanel walletAddress={walletAddress} isTransactionPage={true}/>

            <div className={styles.rightPanel}>
                <ConnectWalletHeader
                    onWalletConnected={(publicKey) => setWalletAddress(publicKey)}
                    showPanel={showPanel}
                    setShowPanel={setShowPanel}
                    emailWallet={emailWalletAddress}
                    onClearAccountData={handleClearAccountData}
                />

                <div className={styles.inviteSection}>
                    <img className={styles.title} src={text_icon} alt="Invite a friend. Earn rewards"></img>
                    <p className={styles.inviteDescription}>
                        Earn 10% bonus on referrals' USDi interest forever, <br/> they keep 100%, you get extra
                        rewards. <span
                        onClick={() => window.open('https://docs.kira.trading/dao/referral-program', '_blank')}
                        style={{color: "#6CE3C4"}}>Learn more. </span>
                    </p>

                    <div className={styles.socialIcons}>
                        {/* X (Twitter) */}
                        <div className={styles.iconContainer} onClick={() => handleShare('x')}>
                            <div>
                                <img className={styles.socialIcon} src={x_icon} alt="x"/>
                            </div>
                            X
                        </div>

                        {/* Telegram */}
                        <div className={styles.iconContainer} onClick={() => handleShare('telegram')}>
                            <div>
                                <img className={styles.socialIcon} src={tele_icon} alt="telegram"/>
                            </div>
                            Telegram
                        </div>

                        {/* WhatsApp */}
                        <div className={styles.iconContainer} onClick={() => handleShare('whatsapp')}>
                            <div>
                                <img className={styles.socialIcon} src={whatsapp_icon} alt="whatsApp"/>
                            </div>
                            WhatsApp
                        </div>

                        {/* QR Code */}
                        <div className={styles.iconContainer} onClick={() => handleShare('qr')}>
                            <div>
                                <img className={styles.socialIcon} src={qr_icon} alt="qr_code"/>
                            </div>
                            QR Code
                        </div>
                    </div>

                    <div className={styles.inviteLinkRow}>
                        {referralCode ? <input
                            type="text"
                            readOnly
                            value={`${APP_URL}/invite-friend/${referralCode}`}
                            className={styles.inviteLinkInput}
                        /> : <input
                            type="text"
                            readOnly
                            value={``}
                            className={styles.inviteLinkInput}
                        />}
                        <button onClick={handleCopy} className={styles.copyButton}>
                            <img className={styles.copyBtn}
                                 src={copy_icon}
                                 alt="copy"></img>
                        </button>
                    </div>

                </div>
                {/* My referrals and rewards container */}
                <div className={styles.myReferralsOuterContainer}>

                    <div className={styles.myReferralsContainer}>
                        <h2 className={styles.myReferralsTitle}>My referrals and rewards</h2>

                        <div className={styles.referralsRow}>
                            {/* Box #1 */}
                            <div className={styles.referralBox}>
                                <p className={styles.boxLabel}>Total Referrals</p>
                                {isReferralsLoading ? (
                                    <span
                                        style={{height: '22px', marginTop: '0px', width: '80px'}}
                                        className={styles.blinkingPlaceholder}
                                    />
                                ) : (
                                    totalReferrals !== '--'
                                        ? <p className={styles.boxValue}>{totalReferrals}</p>
                                        : <p className={styles.boxValue}>--</p>
                                )}
                            </div>

                            {/* Box #2 */}
                            <div className={styles.referralBox}>
                                <p className={styles.boxLabel}>Balances of Referrals</p>
                                {isReferralsLoading ? (
                                    <span
                                        style={{height: '22px', marginTop: '0px', width: '80px'}}
                                        className={styles.blinkingPlaceholder}
                                    />
                                ) : (
                                    balancesOfReferrals !== '--'
                                        ? <p className={styles.boxValue}>{balancesOfReferrals} USDi</p>
                                        : <p className={styles.boxValue}>--</p>
                                )}
                            </div>

                            {/* Box #3 */}
                            <div className={styles.referralBox}>
                                <p className={styles.boxLabel}>Estimated Annual Bonus</p>
                                {isReferralsLoading ? (
                                    <span
                                        style={{height: '22px', marginTop: '0px', width: '80px'}}
                                        className={styles.blinkingPlaceholder}
                                    />
                                ) : (
                                    ninetyDayApy && balancesOfReferrals && ninetyDayApy > 0 && balancesOfReferrals > 0
                                        ?
                                        <p className={styles.boxValue}>${(ninetyDayApy * balancesOfReferrals * 0.8 * 0.1).toFixed(2)}</p>
                                        : <p className={styles.boxValue}>--</p>
                                )}
                            </div>

                            {/* Box #4 */}
                            <div className={styles.referralBox}>
                                <p className={styles.boxLabel}>Earned Rewards</p>
                                {isReferralsLoading ? (
                                    <span
                                        style={{height: '22px', marginTop: '0px', width: '80px'}}
                                        className={styles.blinkingPlaceholder}
                                    />
                                ) : (
                                    earnedRewards !== '--'
                                        ? <p className={styles.boxValue}>{earnedRewards} KRA</p>
                                        : <p className={styles.boxValue}>--</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <KiraQRCodeModal
                isOpen={showQrCodeModal}
                onClose={() => setShowQrCodeModal(false)}
                referralUrl={`https://${APP_URL}/invite-friend/${referralCode}`}
            />
        </div>
    );
}

export default InviteFriends;